/* eslint-disable react/prop-types */
import React from 'react';
import { useState, useEffect } from "react";
import api from "../Api"; // Replace with your actual API service
import ShowDataTable from "../ShowDataTable/ShowDataTable";
import TemplateUploadForm from "../Template/TemplateUploadForm/TemplateUploadForm";
import UploadSuccess from "../UploadSuccess/UploadSuccess";
import styles from "./TemplateTable.module.css";
import WarningModal from "../WarningModal/WarningModal";
import Loader from "../Loader/Loader.js";
import { useLocation } from 'react-router-dom';
import Select from "react-select";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@material-ui/core';
import * as XLSX from "xlsx";
import CloseIcon from '@material-ui/icons/Close';

const TemplateSectionHeaders = [
  "#",
  "Template Name",
  "Category",
  "Status",
  "Actions",
  "Fuel",
  "Last updated by",
  "Last updated on",
];

const TemplateComponent = ({ ApplyClass, categories }) => {
  const location = useLocation();
  const [message, setMessage] = useState("");
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [extractedData, setExtractedData] = useState(null);
  const [showUpdated, setShowUpdated] = useState(false);
  const [showWarning, setShowWarning] = useState(false);
  const [selectedTemplateInfo, setSelectedTemplateInfo] = useState(null);
  const queryParams = new URLSearchParams(location.search);
  const userID = queryParams.get("userID");
  const [errMessage, setErrMessage] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [overwrite, setOverwrite] = useState(null);
  const [updatedTemplateInfo, setUpdatedTemplateInfo] = useState(null);
  const [showConfirmDelete, setShowConfirmDelete] = useState(0);
  const [deleteTemplateId, setDeleteTemplateId] = useState(null);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newFieldName, setNewFieldName] = useState("");
  const [newFieldDesc, setNewFieldDesc] = useState("");
  const [allFields, setAllFields] = useState([]); // store downloaded fields
  const dropdownOptions = [
    { value: "add", label: "Add Fields" },
    { value: "download", label: "Download Fields" },
  ];
  // const dispatch = useDispatch();

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      setShowUploadForm(true);
      // console.log(file);
      // Reset the file input value so the same file can be uploaded again
      event.target.value = null;
    }
  };

  const handleSave = async (updatedInfo) => {
    setUpdatedTemplateInfo(updatedInfo);
    setLoading(true);
    try {
      let url;
      let payload;
      let method;

      if (selectedFile) {
        setMessage("uploaded");
        url = `/uploadTemplate?userID=${userID}`;
        payload = new FormData();
        payload.append("file", selectedFile);
        payload.append("updatedInfo", JSON.stringify(updatedInfo));
        // Remove the Content-Type header - let the browser set it automatically
        method = "POST";
      } else {
        setMessage("updated");
        url = `/updateTemplateInfo?templateID=${selectedTemplateId}&userID=${userID}`;
        payload = updatedInfo;
        method = "PUT";
      }

      // Make the API request with conditional headers
      const response = await api({
        method,
        url,
        data: payload,
        headers: selectedFile
          ? undefined
          : { "Content-Type": "application/json" },
      });

      // Handle the response
      const data = response.data;
      console.log(data);
      setShowUpdated(true);
      setSelectedTemplateId(null);
      setSelectedTemplateInfo(null);
      setSelectedFile(null);
      await fetchUserTemplates(userID);
      setErrMessage(null);
      setOverwrite(null);
      setUpdatedTemplateInfo(null);
    } catch (err) {
      // Handle errors
      setErrMessage(err?.response?.data?.message);
      if (err?.response?.data?.showOverwrite) {
        setOverwrite(err.response.data);
        setShowUploadForm(false);
      }
      console.log(err?.response?.data);
    }
    setLoading(false);
  };

  const onCancel = () => {
    setErrMessage(null);
    setOverwrite(null);
    setShowUploadForm(true);
  };

  const onSave = async () => {
    setLoading(true);
    try {
      // Check if a file is selected
      if (!selectedFile) {
        throw new Error("No file selected. Please select a file to upload.");
      }
      setMessage("uploaded");
      // Delete the existing template if overwrite is required
      if (overwrite?.templateID) {
        const deleteResponse = await api.delete(`/deleteTemplate`, {
          params: { templateID: overwrite.templateID, userID },
        });

        console.log("Template deleted successfully:", deleteResponse.data);
      }

      // Prepare payload for file upload
      const payload = new FormData();
      payload.append("file", selectedFile); // Attach the file
      payload.append("updatedInfo", JSON.stringify(updatedTemplateInfo)); // Include updatedInfo as a JSON string
      const config = { headers: { "Content-Type": "multipart/form-data" } }; // FormData headers

      // Make the API request for file upload
      const response = await api.post(
        `/uploadTemplate?userID=${userID}`,
        payload,
        config,
      );

      await fetchUserTemplates();

      console.log("File uploaded successfully:", response.data);
      setShowUpdated(true);
      setSelectedTemplateId(null);
      setSelectedTemplateInfo(null);
      setSelectedFile(null);
      setErrMessage(null);
      setOverwrite(null);
      setUpdatedTemplateInfo(null);
    } catch (err) {
      console.error("An error occurred:", err?.response?.data || err.message);

      // Optionally, display the error message to the user
      setErrMessage(
        err?.response?.data?.message || "An unexpected error occurred.",
      );
      setShowWarning(true);
    }
    setLoading(false);
  };

  const ErrorMessageComponent = () => (
    <div className={styles.formWrap}>
      <div className={styles.errorContainer}>
        <p className={styles.errorMessage}>{overwrite?.message}</p>
        <div className={styles.buttonGroup}>
          <button className={styles.cancelButton} onClick={onCancel}>
            Cancel
          </button>
          <button className={styles.saveButton} onClick={onSave}>
            <svg
              width="8"
              height="12"
              viewBox="0 0 8 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.589844 10.58L5.16984 6L0.589844 1.41L1.99984 0L7.99984 6L1.99984 12L0.589844 10.58Z"
                fill="#F7F7F8"
              />
            </svg>
            Save
          </button>
        </div>
      </div>
    </div>
  );

  const handleDeleteCancel = () => setShowConfirmDelete(false);
  const handleDeleteTemplate = async () => {
    setLoading(true);
    try {
      const templateID = deleteTemplateId;
      // Send delete request to the API
      const res = await api.delete(`/deleteTemplate`, {
        params: { templateID, userID },
      });

      // Check if the response was successful
      if (res.status === 200) {
        // Refresh the user's templates
        await fetchUserTemplates();
        // Provide success feedback
        setDeleteTemplateId(null);
        setShowConfirmDelete(0);
        setShowUpdated(1);
        setMessage("removed");
      }
    } catch (err) {
      // Handle errors
      setErrMessage(
        err?.response?.data?.message || "An unexpected error occurred.",
      );
      setShowWarning(true);
      console.error("Error deleting template:", err);
    } finally {
      setLoading(false);
      // Close the delete confirmation modal
      setShowConfirmDelete(false);
    }
  };

  const renderDeleteModal = () => (
    <WarningModal
      icon={
        <i
          className="bi bi-exclamation-triangle-fill"
          style={{ color: "#D6746F" }}
        ></i>
      }
      message={`Are you sure you want to delete the template?`}
      okButton="Delete"
      cancelButton="Cancel"
      onCancel={handleDeleteCancel}
      onSave={handleDeleteTemplate}
    />
  );

  const formatDate = (isoDate) => {
    return new Date(isoDate).toLocaleString("en-US", {
      year: "numeric",
      month: "short", // "Feb"
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true, // Use 12-hour format with AM/PM
    });
  };

  const fetchUserTemplates = async () => {
    setLoading(true);
    try {
      await api
        .get(`/getAllTemplates`) // Send userID as query param
        .then((response) => {
          const data = response.data; // Assuming API returns template details in 'data'
          // console.log(data);
          const transformedData = data.map((template) => {
            // Determine emission display
            let emissionDisplay = "-";

            if (template && template.emission_category === "Fuel") {
              emissionDisplay = template.fuel_type || "Fuel type not provided";
            } else if (
              template &&
              (template.emission_category === "Electricity" || template.emission_category === "Others")
            ) {
              emissionDisplay = "Not applicable";
            }

            return [
              template?.template_id,
              template?.name,
              template?.category,
              template?.status === 1 ? "Active" : "Inactive",
              "Actions",
              emissionDisplay,
              template?.updated_by, // Last updated by
              formatDate(template.updated_at), // Last updated on
            ];
          });
          setExtractedData(transformedData); // Set state with fetched data
        })
        .catch((error) => {
          console.error("Error fetching user templates:", error);
        });
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setLoading(false);
    }
  };

  // Fetch user templates from the backend
  useEffect(() => {
    if (userID) {
      fetchUserTemplates();
    }
  }, [userID]);

  useEffect(() => {
    if (selectedTemplateId) {
      api
        .get(`/getTemplateInfo?templateID=${selectedTemplateId}`)
        .then((response) => {
          const data = response.data;
          setSelectedTemplateInfo(data[0]);
        })
        .catch((error) => {
          // Handle errors
          console.error("Error fetching template info:", error);

          // Optional: Display an error message to the user
          console.log(
            "Failed to fetch template information. Please try again.",
          );
        });
    }
  }, [selectedTemplateId]);

  useEffect(() => {
    if (showUpdated) {
      const timer = setTimeout(() => {
        setShowUpdated(false);
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showUpdated]);

  useEffect(() => {
    if (selectedTemplateInfo) {
      setShowUploadForm(true);
    }
  }, [selectedTemplateInfo]);

  if (loading) {
    return <Loader></Loader>
  }

  if (!extractedData) {
    return null;
  }

  const handleDropdownChange = async (selectedOption) => {
    if (selectedOption.value === "add") {
      setDialogOpen(true);
    } else if (selectedOption.value === "download") {
      try {
        const res = await api.get("/downloadTemplateFields", {
          responseType: "blob", // Important: tells axios to expect binary
        });

        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "template_fields.xlsx";
        a.click();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        console.error("Download error:", err);
        setErrMessage("Failed to download fields");
        setShowWarning(true);
      }
    }
  };

  return (
    <div className={styles.cont}>
      <div style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 1.1rem",
        marginBottom: "1rem",
      }}>
        <button
          className={styles.button}
          onClick={() => document.getElementById("fileInput").click()}
        >
          <svg width="30" height="30" viewBox="0 0 24 24" fill="none">
            <path d="M6 5V6.875H19V5H6ZM6 14.375H9.71429V20H15.2857V14.375H19L12.5 7.8125L6 14.375Z" fill="#1232C3" />
          </svg>
          Upload Template
        </button>

        <Select
          options={dropdownOptions}
          onChange={handleDropdownChange}
          placeholder="Manage fields "
          className="react-select"
          styles={{
            control: (base) => ({
              ...base,
              minWidth: 200,
              borderRadius: "0.5rem",
            }),
          }}
        />
      </div>


      <input
        id="fileInput"
        type="file"
        accept=".csv, .xls, .xlsx"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <ShowDataTable
        showSorting={true}
        showMatching={false}
        headerData={TemplateSectionHeaders}
        showTitle={false}
        extractedData={extractedData}
        isTemplateSection={true}
        sectionType={"Template"}
        categories={categories?.map((cat) => cat?.name)}
        setSelectedTemplateId={setSelectedTemplateId}
        onDelete={(templateId) => {
          setShowConfirmDelete(true);
          setDeleteTemplateId(templateId);
        }}
        ApplyClass={ApplyClass}
        showSearchFilter={true}
      />

      {showWarning ? (
        <WarningModal
          icon={
            <i
              className="bi bi-exclamation-triangle-fill"
              style={{ color: "#D6746F" }}
            ></i>
          }
          message={errMessage}
          okButton="OK"
          onSave={() => {
            setShowWarning(false);
            setErrMessage("");
          }}
        />
      ) : null}

      {showConfirmDelete ? renderDeleteModal() : null}
      {overwrite ? ErrorMessageComponent() : null}

      {selectedTemplateInfo || selectedFile ? (
        <TemplateUploadForm
          initialData={selectedTemplateInfo}
          errMessage={errMessage}
          categories={categories}
          onSave={handleSave}
          showUploadForm={showUploadForm}
          onCancel={() => {
            setSelectedTemplateId(null);
            setSelectedTemplateInfo(null);
            setErrMessage(null);
            setSelectedFile(null);
            setOverwrite(null);
            setErrMessage("");
            setUpdatedTemplateInfo(null);
          }}
        />
      ) : null}

      {showUpdated ? (
        <UploadSuccess message={`Template ${message} successfully`} />
      ) : null}

      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>
          Add Field
          <CloseIcon
            aria-label="close"
            onClick={() => setDialogOpen(false)}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </CloseIcon>
        </DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            label="Field Name"
            margin="dense"
            value={newFieldName}
            onChange={(e) => setNewFieldName(e.target.value)}
          />
          <TextField
            fullWidth
            label="Field Description"
            margin="dense"
            value={newFieldDesc}
            onChange={(e) => setNewFieldDesc(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button
            variant="contained"
            disabled={!newFieldName.trim() || !newFieldDesc.trim()}
            style={{
              backgroundColor:
                !newFieldName.trim() || !newFieldDesc.trim()
                  ? "#ccc"
                  : "#1232C3",
              color: "#fff",
              textTransform: "none",
              padding: "6px 16px",
              borderRadius: "6px",
              cursor:
                !newFieldName.trim() || !newFieldDesc.trim()
                  ? "not-allowed"
                  : "pointer",
            }}
            onClick={async () => {
              try {
                const payload = {
                  field: newFieldName,
                  description: newFieldDesc,
                };
                await api.post(`/addTemplateField`, payload);
                setDialogOpen(false);
                setNewFieldName("");
                setNewFieldDesc("");
                setShowUpdated(true);
                setMessage("field added");
              } catch (err) {
                console.error(err);
                setErrMessage("Failed to add field");
                setShowWarning(true);
              }
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>

    </div>

  );
};

export default TemplateComponent;
